export enum ProjectModalTypes {
  MODAL_TYPE_ADD = 'MODAL_TYPE_ADD',
  MODAL_TYPE_VIEW = 'MODAL_TYPE_VIEW',
  MODAL_TYPE_EDIT = 'MODAL_TYPE_EDIT',
  MODAL_TYPE_DELETE = 'MODAL_TYPE_DELETE',
  MODAL_TYPE_COPY = 'MODAL_TYPE_COPY',
  MODAL_TYPE_UNDEFINED = 'MODAL_TYPE_UNDEFINED',
  MODAL_TYPE_ARCHIVE = 'MODAL_TYPE_ARCHIVE'
}